module.exports = __webpack_public_path__ + "static/media/industrial.e7a069a6.gif";